module.exports = __webpack_public_path__ + "static/media/empty.aa8345db.svg";